import React from 'react';
import { Link } from "gatsby"

export default ({to, children}) => <Link className="button button-primary button-shadow"  to={to}>
  {children}
</Link>
